import React, { useState, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from 'utils/I18n/context';

const SuccessString = ({ text, onAction }) => {
    const { t } = useContext(I18nContext);
    const [state, setState] = useState({
        text: text,
        type: text ? 'text' : 'code'
    });

    const staticNames = t?.postbackPage?.creatingEditing || { 
        code: 'Code', 
        codeText: 'Text', 
        enterText: 'Enter text' 
    };

    const onChange = useCallback(() => {
        let text = state.type === 'text' ? state.text : '';

        onAction && onAction(text);
    }, [state.type, state.text, onAction]);

    const onChangeField = useCallback((event) => {
        const name = event.target.name;
        const value = event.target.value;

        setState(prev => ({
            ...prev,
            [name]: value
        }), () => {
            onChange();
        });
    }, [onChange]);

    return (
        <React.Fragment>
            <label className="checkbox-inline option">
                <input
                    className="option__input"
                    type="radio"
                    name={'type'}
                    checked={state.type === 'code'}
                    value={'code'}
                    onChange={onChangeField}
                />
                <span className="option__mark" />
                <span className="option__caption">{staticNames.code}</span>
            </label>
            <label className="checkbox-inline option">
                <input
                    className="option__input"
                    type="radio"
                    name={'type'}
                    checked={state.type === 'text'}
                    value={'text'}
                    onChange={onChangeField}
                />
                <span className="option__mark" />
                <span className="option__caption">{staticNames.codeText}</span>
                {state.type === 'text'
                ? (
                    <label className="checkbox-inline option text">
                        <input
                            className="form-control input-sm"
                            type="text"
                            name="text"
                            value={state.text}
                            onChange={onChangeField}
                            placeholder={staticNames.enterText}
                        />
                    </label>
                )
                : null
            }
            </label>
        </React.Fragment>
    );
};

SuccessString.propTypes = {
    text: PropTypes.string,
    onAction: PropTypes.func
};

SuccessString.defaultProps = {
    text: '',
    onAction: () => {}
};

export default SuccessString;
